<script>
    let { copy, scale } = $props();

    const swatchWidth = 25;

   
    
</script>

<div class='legend-container'>
    <div class="legend-title">{copy.legend}</div>
    <div class="legend-items">
        <div class="categories">
        <!-- Starting point label -->
        <div class="legend-item">
            <div class="legend-label" style="width: auto; text-align: center; margin-top: 10px;">0</div>
        </div>
        {#each scale.domain as tick, ix}
        {@const value = scale.range[ix]}
            <div class="legend-item" >
                <div class="legend-swatch" style="background-color: {value}; width: {swatchWidth}px"></div>
                {#if ix === scale.domain.length - 1}
                    <div class="legend-label" style="width: {swatchWidth}px; text-align: center; transform: translateX({swatchWidth / 2}px); ">{tick}+</div>
                {:else}
                    <div class="legend-label" style="width: {swatchWidth}px; text-align: center; transform: translateX({swatchWidth / 2}px);">{tick}</div>
                {/if}
            </div>
        {/each}
        <div class="legend-item" >
            <div class="legend-swatch" style="background-color: {scale.range[scale.range.length - 1]}; width: {swatchWidth}px"></div>
        </div>
        </div>
    </div>
</div>

<style lang='scss'>
    .legend-container {
        margin: auto;
        // padding-left: 10px;
    }
    .legend-title {
        font-weight: 700;
        font-size: 14px;
        margin-bottom: 3px;
        // text-align: center;
    }
    .legend-items {
        display: flex;
        flex-direction: row;
        gap: 15px;
        // justify-content: center;
    }
    .categories {
        display: flex;
        justify-content: center;

    }

    .legend-swatch {
        height: 8px;
       
    }
    .legend-label {
        font-size: 11px;
        font-weight: 300;
        // text-align: center;
        margin-top: 2px;
        
    }
</style>